<template>
  <div class="user-module w-full">
    <div class="flex mt-8 w-full">
      <div class="flex w-4/5">
        <div class="flex flex-col px-6 w-1/3">
          <div class="form-group">
            <label for="role_id">Tip Zaposlenika</label>
            <v-select
                :tabindex="1"
                class="form-select"
                :class="{ _error: validationErrors['role_id'] }"
                id="role_id"
                v-model="form.role_id"
                :options="roles"
                label="display_name"
                :reduce="(role) => role.id"
                :clearable="false"
            ></v-select>

            <span class="error-message" v-if="validationErrors.role_id" v-text="validationErrors.role_id[0]"></span>
          </div>

          <div class="form-group">
            <label for="price">Cijena sata</label>
            <input
                tabindex="4"
                id="price"
                class="form-control"
                :class="{ _error: validationErrors.price}"
                type="number"
                v-model="form.price"
            >
            <span class="error-message" v-if="validationErrors.price" v-text="validationErrors.price[0]"></span>
          </div>
        </div>

        <div class="flex flex-col px-6 w-1/3">
          <div class="form-group">
            <label for="price_from">Datum od</label>
            <vue-ctk-date-time-picker
                :tabindex="2"
                class="form-datepicker"
                :class="{ _error: validationErrors.price_from }"
                id="price_from"
                v-model="form.price_from"
                label="Odaberite datum od"
                locale="hr"
                format="YYYY-MM-DD"
                formatted="DD.MM.YYYY."
                :only-date="true"
                :noShortcuts="true"
            ></vue-ctk-date-time-picker>
            <span class="error-message" v-if="validationErrors.price_from"
                  v-text="validationErrors.price_from[0]"></span>
          </div>
        </div>

        <div class="flex flex-col px-6 w-1/3">
          <div class="form-group">
            <label for="price_to">Datum do</label>
            <vue-ctk-date-time-picker
                :tabindex="3"
                class="form-datepicker"
                :class="{ _error: validationErrors.price_to }"
                id="price_to"
                v-model="form.price_to"
                label="Odaberite datum do"
                locale="hr"
                format="YYYY-MM-DD"
                formatted="DD.MM.YYYY."
                :only-date="true"
                :noShortcuts="true"
            ></vue-ctk-date-time-picker>
            <span class="error-message" v-if="validationErrors.price_to" v-text="validationErrors.price_to[0]"></span>
          </div>
        </div>
      </div>

      <!-- <div class="flex w-4/5">
          <div class="flex flex-col px-6 w-1/3">
              <div class="form-group flex items-center mt-3">
                  <div class="box-switch">
                      <input
                          tabindex="2"
                          type="checkbox"
                          id="status"
                          name="status"
                          v-model="form.status"
                      >
                      <span class="switch-path"></span>
                      <label for="status" v-text="form.status ? 'Aktivan' : 'Neaktivan'"></label>
                  </div>
                  <span class="error-message" v-if="validationErrors.status" v-text="validationErrors.status[0]"></span>
              </div>
          </div>
      </div> -->
      <div class="flex justify-start items-end w-1/5">
        <div class="flex flex-col">
          <button
              class="btn primary"
              @click="submitForm()"
              :disabled="procesing"
          >Spremi
          </button>
        </div>
      </div>
    </div>
    <div>
      <h2 class="w-full mr-4" v-if="redirectMessage" v-text="redirectMessage"></h2>
    </div>
    <response
        v-if="showResponse"
        :data="responseData"
    ></response>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Response from './Response'

export default {
  components: {
    vSelect,
    VueCtkDateTimePicker,
    Response,
  },

  props: {
    roles: {
      type: Array,
      default: () => ([])
    },
    priceData: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      form: {
        role_id: '',
        price: 0,
        price_from: '',
        price_to: '',
      },
      validationErrors: {},
      redirectMessage: '',
      showResponse: false,
      responseData: {},
      procesing: false,
    }
  },

  created() {
    this.showLoader();
    // Set the inputs to values to given user data
    if (this.priceData.id) {
      _.forEach(this.form, (item, key) => {
        switch (key) {
          default:
            this.form[key] = this.priceData[key]
            break;
        }
      })
    }
    setTimeout(() => {
      this.hideLoader();
    }, 500);
  },

  methods: {
    // Submit the form to create a new customer
    submitForm() {
      this.showLoader();
      this.procesing = true

      let formData = new FormData();
      let endpoint = '';

      // Append all form items
      _.forEach(this.form, (item, key) => {
        switch (key) {
          default:
            formData.append(key, item)
            break;
        }
      })

      // Conditionaly add method to form submit
      if (this.priceData.id) {
        formData.append("_method", 'PATCH');
      }

      // Sets the endpoint with data for store/update depending on create or update
      if (this.priceData.id) {
        let data = {
          price: this.priceData.id,
        }

        endpoint = route('prices.update', data)
      } else {
        endpoint = route('prices.store')
      }

      // Send the formData to customer controller store/update function depending on endpoint
      axios.post(endpoint, formData)
          .then((response) => {
            if (response.status === 200) {
              this.responseData = response.data.data
              this.showResponse = true

              setTimeout(() => {
                this.hideLoader();
                window.location.href = route('prices.index')
              }, 2000);
            }
          })
          .catch((error) => {
            this.procesing = false
            if (typeof (error.response) !== 'undefined')
              this.validationErrors = error.response.data.errors

            console.error(error);
            this.hideLoader();
          });
    },
  }
}
</script>
